import React from "react";
import "./style.css";
import ScrollAnimation from "react-animate-on-scroll";

class SkillSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      html: { class: "", percentage: "0%" },
      css: { class: "", percentage: "0%" },
      javascript: { class: "", percentage: "0%" },
      react: { class: "", percentage: "0%" },
      redux: { class: "", percentage: "0%" }
    };
  }
  show = function(visible) {
    console.log(visible);
    if (visible.inViewport) {
      this.setState({
        html: { class: "html", percentage: "95%" },
        css: { class: "css", percentage: "80%" },
        javascript: { class: "javascript", percentage: "95%" },
        react: { class: "react", percentage: "85%" },
        redux: { class: "redux", percentage: "75%" }
      });
      // Part of the element is in the viewport (the area defined by the offset property)
    } else if (visible.onScreen) {
      // Part of the element is visible on the screen
    } else {
      // Element is no longer visible
      this.setState({
        html: { class: "", percentage: "0%" },
        css: { class: "", percentage: "0%" },
        javascript: { class: "", percentage: "0%" },
        react: { class: "", percentage: "0%" },
        redux: { class: "", percentage: "0%" }
      });
    }
  };
  render() {
    return (
      <div className="col-lg-6 col-md-12">
        <div className="padding-20px-left sm-no-padding">
          <ScrollAnimation
            animateIn="fadeIn"
            duration={0}
            afterAnimatedIn={this.show.bind(this)}
          >
            <div className="skills width-100 margin-40px-bottom sm-margin-30px-bottom xs-no-margin-bottom">
              <div className="prog-item">
                <p>JAVASCRIPT</p>
                <div className="skills-progress">
                  <span
                    data-value={this.state.javascript.percentage}
                    className={this.state.javascript.class}
                  />
                </div>
              </div>
              <div className="prog-item">
                <p>React JS</p>
                <div className="skills-progress">
                  <span
                    data-value={this.state.react.percentage}
                    className={this.state.react.class}
                  />
                </div>
              </div>
              <div className="prog-item">
                <p>Redux JS</p>
                <div className="skills-progress">
                  <span
                    data-value={this.state.redux.percentage}
                    className={this.state.redux.class}
                  />
                </div>
              </div>
              <div className="prog-item">
                <p>HTML</p>
                <div className="skills-progress">
                  <span
                    data-value={this.state.html.percentage}
                    className={this.state.html.class}
                  />
                </div>
              </div>
              <div className="prog-item">
                <p>CSS</p>
                <div className="skills-progress">
                  <span
                    data-value={this.state.css.percentage}
                    className={this.state.css.class}
                  />
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </div>
    );
  }
}
export default SkillSection;
